import r from "react";
import b from "classnames";
import { PaymentAPI as o } from "../../../../js/payments/paymentApi.js";
import a from "./paymentButton.module.scss.js";
import f from "../../../../common/resources/gpay.svg.js";
import d from "../../../../common/resources/apple-pay.svg.js";
import { isInFlight as _ } from "../hooks/paymentStatus.js";
import { usePaymentMethod as h } from "../hooks/usePaymentMethod.js";
function v({
  method: e,
  onClick: p,
  children: u,
  design: t
}) {
  const l = h();
  if (!l)
    throw new Error(
      "PaymentMethodCompound should be inside a PaymentMethodContext provider"
    );
  const {
    activePaymentMethod: y,
    loadingState: P,
    errors: m,
    isFullCashbackPayment: i,
    dueAmount: s,
    paymentStatus: c
  } = l;
  let n = !i && s !== 0;
  return y && (n = !!(P || _(c) || m != null && m.canUseWallet)), /* @__PURE__ */ r.createElement(
    "button",
    {
      "data-testid": "payment-button",
      disabled: n,
      onClick: p,
      className: b({
        [a.submitBtn]: !0,
        [a.submitBtn__disabled]: n,
        [a.submitBtn__apple]: e === o.PaymentMethodType.APPLE_PAY,
        [a.submitBtn__google]: e === o.PaymentMethodType.GOOGLE_PAY
      }),
      type: "button",
      style: {
        "--backgroundColor": (t == null ? void 0 : t.backgroundColor) ?? "#fca2f3",
        "--textColor": (t == null ? void 0 : t.textColor) ?? "#FFF"
      }
    },
    u,
    e === o.PaymentMethodType.GOOGLE_PAY && /* @__PURE__ */ r.createElement(f, null),
    e === o.PaymentMethodType.APPLE_PAY && /* @__PURE__ */ r.createElement(d, null)
  );
}
export {
  v as PaymentButton
};
//# sourceMappingURL=PaymentButton.js.map
